import { DOCUMENT } from '@angular/common';
import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
} from '@angular/core';

@Directive({
  selector: '[numbersOnly]',
})
export class OnlynumberDirective {
  @Input() isNgSelectDropdown: string = '';

  constructor(
    private _el: ElementRef,
    @Inject(DOCUMENT) private document: Document
  ) {}

  @HostListener('keypress', ['$event']) public disableKeys(e: any) {
    if (this.isNgSelectDropdown) {
      this.document.all ? e.keyCode : e.keyCode;
      return e.keyCode == 8 || (e.keyCode >= 48 && e.keyCode <= 57);
    }
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    if (!this.isNgSelectDropdown) {
      const initalValue = this._el.nativeElement.value;

      this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
      if (initalValue !== this._el.nativeElement.value) {
        event.stopPropagation();
      }
    }
  }
}
